export default __webpack_public_path__ + "static/media/i10.8f7896ea.svg";